import { authPut } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";
import { TimeLookbackRange, UpdateFindingBody } from "@types";
import { calculateLookbackSeconds } from "@utils/calculateLookbackSeconds";
import { _getFindingsParamsFromSearch } from "@utils/getFindingsParamsFromSearch";

import { Finding } from "@pages/findings/types";

export const updateDeploymentFindingsBulk = (
  deploymentId: string,
  searchParams: URLSearchParams,
  timeLookbackRange: TimeLookbackRange,
  updates: UpdateFindingBody
) => {
  let queryParams = new URLSearchParams();
  if (searchParams) {
    // Clean up search params
    queryParams = _getFindingsParamsFromSearch(searchParams);
  }
  queryParams.set(
    "since",
    calculateLookbackSeconds(timeLookbackRange).toString()
  );
  if (queryParams.get("tab") === null) {
    queryParams.set("tab", "open");
  }

  return authPut<UpdateFindingBody, Finding[]>(
    `${DEPLOYMENT_URL}/${deploymentId}/issues?${queryParams.toString()}`,
    updates
  );
};
